import { Directive, ElementRef, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

// The purpose of this directive is to mark fields that should be scrolled to if they are invalid when the form is submitted.
// add this directive to the field you want to scroll to when the form is submitted.
// eg.
// <input ag1ScrollField formControlName="name" type="text" />
// ...
// private _formScrollService = inject(FormScrollService);
// private _scrollFields = viewChildren(Ag1ScrollFieldDirective); // capture the directives in a query list
// then when the form is submitted, call this.formScrollService.scrollToFirstInvalidField(this._scrollFields());
@Directive({ selector: '[ag1ScrollField]' })
export class Ag1ScrollFieldDirective {
  // dependencies
  elementRef = inject(ElementRef<HTMLElement>);
  // optional: to allow the directive to be used outside of a form
  // self: to ensure that the directive is injected as the control itself, not as a parent control (e.g. in a group)
  ngControl = inject(NgControl, { optional: true, self: true });

  // A disabled control is neither valid nor invalid, so only an invalid
  // control counts as an error.
  get isValid(): boolean {
    return !this.ngControl?.invalid;
  }

  scrollFieldIntoView(): void {
    const element: HTMLElement = this.elementRef.nativeElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
